import Vue from 'vue'
import moment from 'moment'

const formatterNoDecimalsInput = new Intl.NumberFormat('es-ES', {
  style: 'decimal',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
})

const formatterCurrency = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
})

const formatterNoDecimalsInputPrecision = new Intl.NumberFormat('de-DE', {
  style: 'decimal',
  maximumFractionDigits: 6,
  minimumFractionDigits: 0
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
})

Vue.filter('formatDate', function (value) {
  if (!value) {
    return 'Sin definir'
  }
  return moment(value).format('DD/MM/YYYY')
})

Vue.filter('formatTime', function (value) {
  if (!value) {
    return 'Sin definir'
  }
  return moment(value).format('HH:mm')
})

Vue.filter('decimalInput', function (value) {
  if (value === null || value === undefined) {
    return null
  }
  let resultado = formatterNoDecimalsInput.format(value)
  if (!isNaN(value)) {
    return resultado
  } else {
    return value
  }
})

Vue.filter('removeDecimalInput', function (value) {
  if (value === null || value === undefined) {
    return null
  }
  let aux = value.replace(/\./g, '')
  aux = aux.replace(',', '.')
  return aux
})

Vue.filter('currency', function (value) {
  if (value === null || value === undefined) {
    return formatterCurrency.format(0)
  }
  return formatterCurrency.format(value)
})

Vue.filter('decimalInputPrecision', function (value) {
  if (value === null || value === undefined) {
    return null
  }
  let resultado = formatterNoDecimalsInputPrecision.format(value)
  if (!isNaN(value)) {
    return resultado
  } else {
    return value
  }
})
